import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { IProduct } from "../../sdk/types";
import { api } from "../../sdk/utils";

export interface ICreateProductVariantParameters {
    productId: string;
    title: string;
    shopifyVariantId: string;
    price: number;
    mrp: number;
    shippingPrice: number;
    sku: string;
    position: number;
    status: number;
    meta: Record<string, unknown>;
    amazonRedirectUrl?: string | null;
    flipkartRedirectUrl?: string | null;
}

export const useCreateProductVariant = (
    invalidQueryKeys: string | string[],
): UseMutationResult<IProduct, unknown, ICreateProductVariantParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IProduct, unknown, ICreateProductVariantParameters>({
        mutationFn: async (parameters: ICreateProductVariantParameters) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot create product variant without authorization token.",
                );
            }

            return await api.Products.createVariant({
                ...parameters,
                token: auth.token,
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
